import React from 'react';
import type { FC } from 'react';
import { Alert, useExit } from '@wix/cli-ui-kit';
import { SiteSelector } from '@wix/cli-site-selector';
import { useBiLogger } from '@wix/cli-telemetry-react';
import { useProjectModel } from '../../../../model.js';

interface Props {
  onSubmit: (siteId: string) => void;
}

export const ResolveSite: FC<Props> = ({ onSubmit }) => {
  const exit = useExit();
  const { model } = useProjectModel();
  const biLogger = useBiLogger();

  return (
    <>
      <Alert type="insight">
        You don't have a development site currently configured.
      </Alert>
      <SiteSelector
        appId={model.config.appId}
        biLogger={biLogger}
        onSubmit={(site) => onSubmit(site.id)}
        onError={exit}
      />
    </>
  );
};
